module.exports = __webpack_public_path__ + "media/images/result-banner-0d36704416cc443cfe1209d0764c9a5f.png";